import React, { Component } from 'react';
import Cropper from 'react-cropper';
import { Button, notification } from '@ss/mtd-react';
import { isEqual } from '@block/utils';
import 'cropperjs/dist/cropper.css';
import WorkCard from '../WorkCard';
import cardDefault from './imgs/card-default-crop.png';
import { doAction } from '../../utils';
import './index.scss';

/* eslint-disable */
if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function (callback: (obj: Blob) => void, type: string, quality?: DefaultAny) {
      var canvas: HTMLCanvasElement = this;
      setTimeout(function () {
        var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
          len = binStr.length,
          arr = new Uint8Array(len);

        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback(
          new Blob([arr], {
            type: type || 'image/png',
          }),
        );
      });
    },
  });
}

interface Props extends DefaultToFormItem {
  canReload?: boolean;
  isMrnAble?: boolean;
}

interface State {
  value: string;
  cropResult: any;
  isUploading: boolean;
}

export default class PhotoCrop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { value } = this.props;
    this.state = {
      value: value || null,
      cropResult: null,
      isUploading: false,
    };
    this.imageModified = false;
    this.cropImage = this.cropImage.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.setPhoto = this.setPhoto.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  imageModified: boolean;
  cropper: DefaultAny;
  initData: any;
  upload: HTMLElement;

  componentDidMount() {
    if (this.cropper) {
      this.cropper.img.addEventListener('ready', this.getInitDropBoxData);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({
        value,
      });
    }
  }

  componentWillUnmount() {
    if (this.cropper) {
      this.cropper.img.removeEventListener('ready', this.getInitDropBoxData);
    }
  }

  getInitDropBoxData = () => {
    this.initData = this.cropper.getCropBoxData();
  };

  /**
   * 判断照片是否修改过，判断条件有如下两种
   * 1. 更换了新的照片
   * 2. 照片裁剪区域变化
   * @returns (Boolean)
   */
  getPhotoModified() {
    // 是否更换照片
    if (this.imageModified) return this.imageModified;
    if (this.cropper) {
      // 裁剪区域是否变化
      const currentData = this.cropper.getCropBoxData();
      if (!isEqual(currentData, this.initData)) {
        this.imageModified = true;
      }
    }
    return this.imageModified;
  }

  onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const { onChange } = this.props;
    this.imageModified = true;
    e.preventDefault();
    let file: File = null;
    // @ts-ignore
    if (e.dataTransfer) {
      // @ts-ignore
      file = e.dataTransfer.files[0];
    } else if (e.target) {
      file = e.target.files[0];
    }
    e.target.value = null;
    if (!file) {
      return null;
    }
    const name = file ? file.name : '';
    if (!this.validateImage(name)) {
      notification.error({
        message: '您上传的照片不符合标准，仅支持JPG、JPEG、PNG格式',
        duration: 4000,
      });
      return null;
    }

    if (file.size > 1024 * 1024 * 15) {
      notification.error({
        message: '图片不得大于15M',
        duration: 4000,
      });
      return null;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.setState({ value: reader.result as string });
    };
    reader.readAsDataURL(file);
    onChange && onChange(file);
    return null;
  };

  setPhoto(photoUrl: string) {
    this.setState({ value: photoUrl });
  }

  validateImage = (name: string) => {
    const array = name.split('.');
    const ext = array[array.length - 1].toLowerCase();
    const type = ['png', 'jpeg', 'jpg'];
    return type.indexOf(ext) !== -1;
  };

  cropImage(callback: BlobCallback) {
    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return null;
    }
    const radio = 3; // radio 6.3 max size close to 10M
    const canvas: HTMLCanvasElement = this.cropper.getCroppedCanvas({
      maxWidth: 390 * radio,
      maxHeight: 560 * radio,
      width: 390 * radio,
      height: 560 * radio,
    });
    if (!canvas) {
      notification.error({
        message: '照片加载中，稍后再试',
        duration: 4000,
      });
      return null;
    }
    return canvas.toBlob(callback);
  }

  uploadImage = () => {
    const { value } = this.state;
    return new Promise((resolve, reject) => {
      if (!value) {
        resolve(null);
        return;
      }
      if (value) {
        this.cropImage((blob) => {
          resolve(blob);
        });
      }
    });
  };

  reloadImg = async () => {
    const { onChange } = this.props;
    const { photoUrl } = await doAction('/api/card/image/getuserphoto');
    this.setState({ value: photoUrl });
    onChange && onChange(photoUrl);
  };

  render() {
    const { value } = this.state;
    const { canReload = false, isMrnAble } = this.props;

    const lastTwoCharacter = (value || '').substr((value || '').length - 2);
    const accessToken = window.location.href.split('&token=')[1];

    return (
      <div className="photo-crop-wrapper">
        <div className="viewer">
          <div className="viewer-card">
            <WorkCard
              name={name}
              photoUrl={
                lastTwoCharacter === 'do' && value && isMrnAble
                  ? `https://hr.meituan.com/oauth/getpic?app_key=31020M2779i04021&access_token=${accessToken}&source_uri=${encodeURIComponent(
                      `https://ruzhi.meituan.com/${value}`,
                    )}`
                  : value || cardDefault
              }
              id="myworkcard"
            />
          </div>
        </div>
        <div className="photo-crop">
          <Cropper
            className="cropper cropperFormal"
            aspectRatio={0.8797}
            autoCropArea={0.98}
            preview="#myworkcard"
            guides={false}
            movable={false}
            checkCrossOrigin={false}
            checkOrientation={false}
            scalable={false}
            viewMode={2}
            src={
              lastTwoCharacter === 'do' && value && isMrnAble
                ? `https://hr.meituan.com/oauth/getpic?app_key=31020M2779i04021&access_token=${accessToken}&source_uri=${encodeURIComponent(
                    `https://ruzhi.meituan.com/${value}`,
                  )}`
                : value || cardDefault
            }
            zoomable={false}
            ref={(cropper) => (this.cropper = cropper)}
          />
          <div className="upload-btn">
            <input
              type="file"
              accept="image/png,image/jpg,image/jpeg"
              onChange={this.onChange}
              ref={(ref) => (this.upload = ref)}
            />
            {canReload && (
              <Button onClick={() => this.reloadImg()} style={{ marginRight: 20 }}>
                恢复默认
              </Button>
            )}
            <Button
              onClick={() => {
                this.upload.click();
              }}
            >
              上传照片
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
